import React from "react";
import PropTypes from "prop-types";

// Placeholders shaped like the real content, so nothing shifts when icons arrive

const range = (count) => Array.from({ length: count }, (_, i) => i);

// Vary name widths a little so the grid doesn't look stamped out
const NAME_WIDTHS = ["70%", "55%", "80%", "62%", "48%", "75%"];

export const TileSkeleton = ({ count, listView, className }) => (
  <div
    className={`icon-list${listView ? " icon-list-view" : ""} ${className}`}
    aria-hidden="true"
  >
    {range(count).map((i) => (
      <div className="icon-box" key={i}>
        <div className="icon icon--skeleton">
          <span className="skeleton skeleton--icon" />
          <span
            className="skeleton skeleton--text"
            style={{ width: NAME_WIDTHS[i % NAME_WIDTHS.length] }}
          />
        </div>
      </div>
    ))}
  </div>
);

TileSkeleton.propTypes = {
  count: PropTypes.number,
  listView: PropTypes.bool,
  className: PropTypes.string,
};

TileSkeleton.defaultProps = {
  count: 21,
  listView: false,
  className: "",
};

// A category heading plus its grid; announces loading to screen readers when `label` is set
export const SectionSkeleton = ({ count, listView, label }) => (
  <div className="section-skeleton" role={label ? "status" : undefined}>
    {label ? <span className="sr-only">{label}</span> : null}
    <div className="icon-controller-box" aria-hidden="true">
      <div>
        <span className="skeleton skeleton--title" />
        <span className="skeleton skeleton--count" />
      </div>
    </div>
    <TileSkeleton count={count} listView={listView} />
  </div>
);

SectionSkeleton.propTypes = {
  count: PropTypes.number,
  listView: PropTypes.bool,
  label: PropTypes.string,
};

SectionSkeleton.defaultProps = {
  count: 21,
  listView: false,
  label: "",
};

export const CategoryNavSkeleton = ({ count }) =>
  range(count).map((i) => (
    <li key={i} className="category-nav__skeleton" aria-hidden="true">
      <span className="skeleton skeleton--dot" />
      <span className="skeleton skeleton--label" style={{ width: NAME_WIDTHS[i % NAME_WIDTHS.length] }} />
    </li>
  ));

CategoryNavSkeleton.propTypes = {
  count: PropTypes.number,
};

CategoryNavSkeleton.defaultProps = {
  count: 10,
};
